import service from "@/libs/service";

export const namespaced = true;

export const state = {
    user: null,
    token: null,
    match: null,
    postulations: null
};

export const mutations = {
    SET_USER_DATA(state, content) {
        delete content.user.password;
        if (content.user)
            state.user = content.user;
        if (content.token)
            state.token = content.token;
        if (content.match) 
            state.match = content.match;
        localStorage.setItem("user", JSON.stringify({
            user: state.user,
            token: state.token
        }));
        axios.defaults.headers.common.Authorization = `Bearer ${state.token}`;
        /// Se ejecuta signal de login ///
    },
    REPLACE_USER_DATA(state, content) {
        delete content.user.password;
        state.user = {
            ...content.user
        };
        localStorage.setItem("user", JSON.stringify({
            user: state.user,
            token: state.token
        }));
    },
    SET_USER_ORGANIZATION(state, organization) {
        state.user.organization = organization;
        localStorage.setItem("user", JSON.stringify({
            user: state.user,
            token: state.token
        }));
    },
    CLEAR_USER_DATA(state) {
        if (this.getters["users/loggedIn"]) {
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            state.user = null;
            state.postulations = null;
            state.token = null;
        }
    },
    SET_USER_POSTULATIONS(state, postulations) {
        state.postulations = postulations;
    },
};

export const actions = {
    register({ commit }, credentials) {
        return new Promise((resolve, reject) => {
            service.request("/user/register", credentials).then(content => {
                if (content && content.token && content.user) {
                    commit("SET_USER_DATA", content);
                }
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    invite({ commit }, invitation) {
        return new Promise((resolve, reject) => {
            service.request("/user/invite", {
                invitation
            }).then(content => {
                resolve({
                    userId: content.userId
                });
            }).catch(err => {
                reject(err);
            });
        });
    },
    login({ commit }, credentials) {
        return new Promise((resolve, reject) => {
            service.request("/user/login", credentials).then(content => {
                commit("SET_USER_DATA", content);
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    update({ commit }, user) {
        return new Promise((resolve, reject) => {
            service.request("/user/update", {
                user
            }).then((content) => {
                commit("SET_USER_DATA", { user });
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    remove({ commit }, params) {
        return new Promise((resolve, reject) => {
            service.request("/user/remove", {
                userId: params.userId,
                email: params.email
            }).then(() => {
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    updatePassword({ commit }, credentials) {
        return new Promise((resolve, reject) => {
            service.request("/user/password/update", credentials).then(content => {
                commit("SET_USER_DATA", content);
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    forgetPassword({ commit }, credentials) {
        return new Promise((resolve, reject) => {
            service.request("/user/password/forget", credentials).then(content => {
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    updateOrganization({ commit }, organization) {
        return new Promise((resolve, reject) => {
            service.request("/organization/update", {
                organization
            }).then(() => {
                // commit("SET_USER_ORGANIZATION", organization);
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    getUsersByOrg({ commit }, organizationId) {
        return new Promise((resolve, reject) => {
            service.request(`/user/list/${organizationId}`).then((content) => {
                resolve(content.users);
            }).catch(err => {
                reject(err);
            });
        });
    },
    list({ commit }, organization) {
        return new Promise((resolve, reject) => {
            service.request("/user/list").then((content) => {
                resolve(content.users);
            }).catch(err => {
                reject(err);
            });
        });
    },
    test({ commit }, { searchText, page, limit }) {
        return new Promise((resolve, reject) => {
            service.request("/user/test", { page, limit, searchText }).then((content) => {
                resolve(content.users);
            }).catch(err => {
                reject(err);
            });
        });
    },
    logout({ commit }) {
        commit("CLEAR_USER_DATA");
    },
    saveUserData({ commit }, data) {
        return new Promise((resolve, reject) => {
            localStorage.setItem(data.offerId.toString(), JSON.stringify(data));
            resolve(data);
        });
    },
    postulate({ commit }, data) {
        return new Promise((resolve, reject) => {
            service.request("/offers/postulate", data).then(result => {
                resolve(result);
            }).catch(err => {
                reject(err);
            });
        });
    },
    redirect({ commit }, data) {
        return new Promise((resolve, reject) => {
            service.request("/offers/redirect", data).then(result => {
            }).catch(err => {
                reject(err);
            });
        });
    },
    postulations({ commit }) {
        return new Promise((resolve, reject) => {
            service.request("/user/postulations").then(postulations => {
                commit("SET_USER_POSTULATIONS", postulations);
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    postUpdate({ commit }, data) {
        return new Promise((resolve, reject) => {
            service.request("/offers/postulations/update", data).then((result) => {
                resolve(result);
            }).catch(err => {
                reject(err);
            });
        });
    },
    getOrg({ commit }, slug) {
        return new Promise((resolve, reject) => {
            service.request(`/organizations/slug/${slug}`).then((content) => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    experienceUpdate({ commit, state }, newExperience) {
        // /user/update/experience
        return new Promise((resolve, reject) => {
            service.request("/user/update/experience", { experience: newExperience }).then((content) => {
                let user = {
                    ...state.user,
                    userExperiences: content.experiences
                };
                commit("REPLACE_USER_DATA", { user });
                resolve(user);
            }).catch(err => {
                reject(err);
            });
        });
    },
    experienceRemove({ commit, state }, id) {
        // /user/update/experience
        return new Promise((resolve, reject) => {
            service.request("/user/remove/experience", { experienceId: id }).then((content) => {
                let user = {
                    ...state.user,
                    userExperiences: content.experiences
                };
                commit("REPLACE_USER_DATA", { user });
                resolve(user);
            }).catch(err => {
                reject(err);
            });
        });
    }


};

export const getters = {
    loggedIn(state) {
        return !!state.user;
    },
    getMatch(state) {
        return state.match;
    },
    getUser(state) {
        return state.user;
    },
    getType(state) {
        let type = null;
        if (state.user) type = state.user.type;
        return type;
    },
    getRole(state) {
        let role = null;
        if (state.user) role = state.user.role;
        return role;
    },
    getOrganization(state) {
        let organization = null;
        if (state.user) organization = state.user.organization;
        return organization;
    },
    getPostulations(state) {
        let postulations = null;
        if (state.postulations) postulations = state.postulations;
        return postulations;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};
